module.exports = __webpack_public_path__ + "img/oversecured_image_presentation.7c2cdd1a.webp";